import config from "./config";
var axios = config();

export default {
  getAllprojects() {
    return axios.get("/api/projects/");
  },

  getProjectsByAsurite(asurite) {
    return axios.get("/api/projects/?asurite=" + asurite);
  },

  getProject(id) {
    return axios.get("/api/projects/" + id);
  },

  getStatuses() {
    return axios.get("/api/projects/statuses");
  },
  getRoles() {
    return axios.get("/api/projects/roles");
  },

  getTypes() {
    return axios.get("/api/projects/types");
  },

  getSources() {
    return axios.get("/api/projects/sources");
  },

  createProject(project) {
    return axios.post("/api/projects", project);
  },

  updateProject(project) {
    return axios.put("/api/projects/" + project.id, project);
  },

  createCommunityPartnerprojects(id, items) {
    return axios.post("/api/projects/" + id + "/communityPartners", items);
  },

  createProjectCollaborators(id, items) {
    return axios.post("/api/projects/" + id + "/collaborators", items);
  },

  lastUpdated() {
    return axios.get("/api/projects/updated");
  },

  getByTag(tagId) {
    return axios.get("/api/projects/tag/" + tagId);
  }
};
